import PropTypes from 'prop-types'

import { MainMenuFragmentFragment } from '../../../graphql/gatsby'
import { SanityShouldDisplayRoleAndContextBasedContent } from '../../../lib/sanity'
import { sanityLinkPropTypes } from '../objects/link'

export const sanityMenuEntryPropTypes = {
  name: PropTypes.string,
  link: PropTypes.shape(sanityLinkPropTypes),
  newColumn: PropTypes.bool,
  childEntries: PropTypes.array,
}

export type SanityMenuEntryProps = PropTypes.InferProps<typeof sanityMenuEntryPropTypes>

type MainMenuEntry = NonNullable<NonNullable<MainMenuFragmentFragment['mainMenu']>[number]>
type SubMenuEntries = NonNullable<MainMenuEntry['childEntries']>
type SubMenuEntry = NonNullable<SubMenuEntries[number]>
type SubMenuChildEntry = NonNullable<NonNullable<SubMenuEntry['childEntries']>[number]>

export const filterMenuEntriesToDisplay =
  (shouldDisplay: SanityShouldDisplayRoleAndContextBasedContent) =>
  (menuEntries?: SubMenuEntry['childEntries']): SubMenuChildEntry[] =>
    menuEntries?.filter(
      (subMenuEntry): subMenuEntry is SubMenuChildEntry =>
        !!subMenuEntry && shouldDisplay(subMenuEntry),
    ) ?? []
